import {VerifyService} from "../../service/VerifyService";

export const TimeoutDocumentFrontStepViewModel = () => {

    const timeout = async (verificationId: string) => {
        const currentStep = await VerifyService.getInstance().getCurrentStep(verificationId!!)
        localStorage.setItem("next-step", currentStep.token)
        await VerifyService.getInstance().timeoutDocumentFrontStep(verificationId)
    }

    return {
        timeout
    }

}